import {Injectable} from '@angular/core';
import {StorageService} from './storage/storage.service';
import {STORAGE_KEYS} from '@shared/constants/storage-keys';
import {Login} from '../models/login';
import {SafeLoginDetails} from '../models/safe-login-details';
import {SafeJudgeLoginDetails} from '../models/safe-judge-login-details';
import {UserDetails} from '../models/user-details';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private storage: StorageService) {
  }

  /* ===================== SET SESSION ===================== */

  setSession(response: UserDetails): void {
    if (!response?.authHeader) return;

    /* ================= ADMIN / NORMAL LOGIN ================= */
    if (response.login) {
      // 🔐 Save admin token
      this.storage.set(STORAGE_KEYS.TOKEN, response.authHeader);

      // 👤 Save admin user
      this.storage.set(STORAGE_KEYS.USER, {
        loginId: response.login.loginId,
        userName: response.login.userName,
        userType: response.login.userType,
        role: response.login.role,
        registrationId: response.login.registrationId,
        name: response.login.name,
        phoneNumber: response.login.phoneNumber,
        countryCode: response.login.countryCode,
        whatsappNumber: response.login.whatsappNumber,
        emailId: response.login.emailId
      });
    }
  }



  /* ===================== GET TOKEN ===================== */

  getToken(): string | null {
    return (
      this.storage.getString(STORAGE_KEYS.TOKEN)               // admin
    );
  }


  /* ===================== GET USER ===================== */

  getUser(): SafeLoginDetails | null {
    return (
      this.storage.get<SafeLoginDetails>(STORAGE_KEYS.USER)
    );
  }


  /* ===================== AUTH HELPERS ===================== */

  isLoggedIn(): boolean {
    return !!this.getToken();
  }

  getUserType(): string | null {
    return this.getUser()?.userType ?? null;
  }

  /* ===================== LOGOUT ===================== */
  logout(): void {
    // Admin
    this.storage.remove(STORAGE_KEYS.TOKEN);
    this.storage.remove(STORAGE_KEYS.USER);
    this.storage.clear();
  }

}
